import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { Footer } from '../../components/Footer/Footer';
import { useSelector } from 'react-redux';
import { pathHome } from '../../path';

export default function IndexPage() {
  const navigate = useNavigate();
  const userAuth = useSelector((state) => state.user.userAuth);

  useEffect(() => {
    if (!userAuth) {
      navigate(`/${pathHome}`);
    }
  }, []);
  return (
    <>
      <div className="content">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
